/* eslint-disable no-unused-vars */
import React, { ChangeEvent } from "react";
import { Input, Form } from "antd";
import ModalComponent from "components/Common/Modal/Modal";
import "./Product.scss";

interface RenameProductModalProps {
  isRenameModalVisible: boolean;
  renameProduct: () => void;
  cancelRenameProduct: () => void;
  renameProductName: string;
  renameGroupName: string;
  setRenameProductName: (value: string) => void;
  setRenameGroupName: (value: string) => void;
}

const RenameProductModal: React.FC<RenameProductModalProps> = ({
  isRenameModalVisible,
  renameProduct,
  cancelRenameProduct,
  renameProductName,
  renameGroupName,
  setRenameProductName,
  setRenameGroupName,
}: RenameProductModalProps) => {
  const [form] = Form.useForm();

  const onOk = () => {
    form.validateFields().then(() => {
      renameProduct();
    });
  };

  return (
    <ModalComponent
      title="Rename Product"
      visible={isRenameModalVisible}
      onOK={onOk}
      onCancel={cancelRenameProduct}
      okText="Save"
      cancelText="Cancel"
      dataTestSelector="popRenameProduct"
      zIndex={10}
      isMaskClosable={true}
      className="standard-modal"
    >
      <Form form={form} layout="vertical" initialValues={{ renameProductName, renameGroupName }}>
        <Form.Item
          name="renameProductName"
          rules={[
            {
              required: true,
              message: "Please enter the product name.",
            },
            {
              max: 100,
              message: "The product name must be 100 characters.",
            },
          ]}
        >
          <Input
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setRenameProductName(event.target.value)
            }
          />
        </Form.Item>
        <Form.Item><div className="form-input-title">Rename Group</div></Form.Item>
        <Form.Item
          name="renameGroupName"
          rules={[
            {
              max: 100,
              message: "The group name must be 100 characters.",
            },
          ]}
        >
          <Input
            className="rename-group-form-input"
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setRenameGroupName(event.target.value)
            }
          />
        </Form.Item>
      </Form>
    </ModalComponent>
  );
};

export default RenameProductModal;
